module["exports"] = ["gmail.com", "yahoo.co.in", "hotmail.com"];